import { HTTP } from './http-common';

export default {
    getFlyWirePaymentOrder(payment) {
        return HTTP.post('/payments/flyWire/createOrder', payment);
    },
};
